import { render } from "./InvoiceFunctionCard.vue?vue&type=template&id=0fa31ae0"
import script from "./InvoiceFunctionCard.vue?vue&type=script&lang=js"
export * from "./InvoiceFunctionCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__